(function () {
  if (customElements.get('ce-pagination-load-more') !== undefined) {
    return;
  }

  class PaginationLoadMore extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        collection: 'ce-collection',
        button: '[data-pagination-load-more-button]',
        iconSpinnerContainer: '[data-pagination-load-more-icon-spinner-container]',
        iconSpinner: '[data-pagination-load-more-icon-spinner-container] > svg',
      };

      this.elements = null;

      this.nextPosition = this.getAttribute('next-position');
      this.url = this.getAttribute('url');

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        collection: document.querySelector(this.selectors.collection),
        button: this.querySelector(this.selectors.button),
        iconSpinnerContainer: this.querySelector(this.selectors.iconSpinnerContainer),
        iconSpinner: this.querySelector(this.selectors.iconSpinner),
      };

      this.elements.button.addEventListener('click', this.handleClickButton);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.handleClickButton);
    }

    handleClickButton() {
      if (this.elements.button.hasAttribute('aria-disabled')) {
        return;
      }

      this.elements.button.setAttribute('aria-disabled', 'true');
      this.playAnimationLoading();
      this.elements.collection.paginateLoadMore(this.url, this.nextPosition);
    }

    playAnimationLoading() {
      requestAnimationFrame(() => {
        this.elements.iconSpinnerContainer.style.display = 'flex';
      });

      const keyframes = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 2000 * 6 : 2000,
        iterations: Infinity,
        fill: 'both',
      };

      this.elements.iconSpinner.animate(keyframes, options);
    }
  }

  customElements.define('ce-pagination-load-more', PaginationLoadMore);
})();
